module.exports = __webpack_public_path__ + "img/sport.17f233d2.png";